import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import Dashboard from "./pages/Dashboard";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentFailedPage from "./pages/PaymentFailedPage";
import HelpFAQPage from "./pages/HelpFAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ProtectedRoute from "./components/ProtectedRoute";

import GooglePlayReview from "./pages/dashboard/GooglePlayReview";
import BillingPayment from "./pages/dashboard/BillingPayment";
import AccountSettings from "./pages/dashboard/AccountSettings";
import PrivacyTerms from "./pages/dashboard/PrivacyTerms";
import ReferralPage from "./pages/dashboard/ReferralPage";
import AddGooglePlayAppPage from "./pages/dashboard/AddGooglePlayAppPage";
import AppDetailPage from "./pages/dashboard/AppDetailPage";
import ConnectedAppPage from "./pages/dashboard/ConnectedAppPage";
import AutoReplySimulationPage from "./pages/dashboard/AutoReplySimulationPage";
import EditAppPage from "./pages/dashboard/EditAppPage";
import ChangePasswordPage from "./pages/dashboard/ChangePasswordPage";

import AppStoreReview from "./pages/dashboard/AppStore/AppStoreReview";
import ConnectedAppleAppPage from "./pages/dashboard/AppStore/ConnectedAppleAppPage";
import AppleAutoReplySimulationPage from "./pages/dashboard/AppStore/AppleAutoReplySimulationPage";
import EditAppleAppPage from "./pages/dashboard/AppStore/EditAppleAppPage";
import AddAppStoreAppPage from "./pages/dashboard/AppStore/AddAppStoreAppPage";
import AppleAppDetailPage from "./pages/dashboard/AppStore/AppleAppDetailPage";

import GooglePlayCheckoutPage from "./pages/dashboard/GooglePlayCheckoutPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/reset-password/:email/:token" element={<ResetPasswordPage />} />

        <Route path="/help-faq" element={<HelpFAQPage />} />
        <Route path="/help-faq/:id" element={<HelpFAQPage />} />

        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-failed" element={<PaymentFailedPage />} />

        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />

        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<GooglePlayReview />} />
          <Route path="google-play-review" element={<GooglePlayReview />} />
          <Route path="google-play-review/:package_name" element={<ConnectedAppPage />} />
          <Route path="google-play-review/:package_name/simulation" element={<AutoReplySimulationPage />} />
          <Route path="google-play-review/:package_name/edit" element={<EditAppPage />} />
          <Route path="add-google-play-app" element={<AddGooglePlayAppPage />} />
          <Route path="add-google-play-app/app-detail" element={<AppDetailPage />} />
          
          <Route path="app-store-review" element={<AppStoreReview />} />
          <Route path="app-store-review/:app_id" element={<ConnectedAppleAppPage />} />
          <Route path="app-store-review/:app_id/simulation" element={<AppleAutoReplySimulationPage />} />
          <Route path="app-store-review/:app_id/edit" element={<EditAppleAppPage />} />
          <Route path="add-app-store-app" element={<AddAppStoreAppPage />} />
          <Route path="add-app-store-app/app-detail" element={<AppleAppDetailPage />} />

          <Route path="billing-payment" element={<BillingPayment />} />
          <Route path="billing-payment/:product_id/checkout" element={<GooglePlayCheckoutPage />} />
          <Route path="account-settings" element={<AccountSettings />} />
          <Route path="account-settings/change-password" element={<ChangePasswordPage />} />
          <Route path="privacy" element={<PrivacyTerms />} />
          <Route path="referral" element={<ReferralPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
